// extracted by mini-css-extract-plugin
export var content = "_dz-3";
export var list = "_dz-4";
export var settingsContent = "_dz-7";
export var settingsPanel = "_dz-8";
export var state = "_dz-6";
export var triggerBadge = "_dz-2";
export var triggerButton = "_dz-1";
export var triggerShell = "_dz-0";
export var unreadDot = "_dz-5";